<table
  mat-table
  [dataSource]="dataSource"
  [trackBy]="_trackBy"
  recycleRows
  class="w-full"
  >
  <ng-container matColumnDef="file">
    <th mat-header-cell *matHeaderCellDef>File</th>

    <td mat-cell *matCellDef="let entry">
      <a
        [href]="entry.downloadUri"
        [download]="entry.originalFileName"
        target="_blank"
        [type]="entry.mimetype"
        (click)="_downloadAttachment($event, entry)"
        matTooltip="Click to download file"
        class="break-all text-sm"
        >
        {{ entry.originalFileName }}
      </a>

      @if (entry.file) {
        <span
          matTooltip="New attachment (will be added when saving)"
          >
          &nbsp;
          <mat-chip-set>
            <mat-chip class="disable-click">new</mat-chip>
          </mat-chip-set>
        </span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="preview">
    <th
      mat-header-cell *matHeaderCellDef
      class="!text-center"
      >
      Preview
    </th>

    <td mat-cell *matCellDef="let entry" class="text-center">
      <a
        [href]="entry.downloadUri"
        [download]="entry.originalFileName"
        target="_blank"
        [type]="entry.mimetype"
        (click)="_downloadAttachment($event, entry)"
        >
        @if (entry.previewType === 'media') {
          <app-thumbnail
            [src]="entry.previewUri"
            [fullSizeSrc]="entry.downloadUri"
            class="thumbnail-border rounded" />
        } @else {
          <div class="[--size:46px] min-w-[--size] h-[--size] w-full
            p-2
            flex
            items-center
            justify-center
            extension-preview-background
            extension-preview-text-color
            extension-preview-typography
            rounded"
            [matTooltip]="entry.fileExtension ? '.' + entry.fileExtension + '-file' : 'Unknown file type'"
          >
            @if(!entry.fileExtension) {
              <span class="inline-block">&lt;none&gt;</span>
            } @else {
              <span class="inline-block overflow-hidden text-ellipsis max-w-[calc(var(--size)_*_1.2)]">{{ entry.fileExtension }}</span>
            }
          </div>
        }

      </a>
    </td>
  </ng-container>

  <!--
  Action button column

  For now contains only the delete button
  -->
  <ng-container matColumnDef="actions">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="!text-center"
      >
      Delete
    </th>

    <td
      mat-cell
      *matCellDef="let entry"
      class="text-center"
      >
      <button
        mat-icon-button
        (click)="_removeAttachment(entry)"
        matTooltip="Delete"
        >
        <ion-icon name="trash-outline"></ion-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>

  <tr *matNoDataRow>
    <td colspan="3" class="text-center">
      No attachments
    </td>
  </tr>
</table>
